<template>
  <el-dialog
      title="生成标识"
      width="800px"
      ref="form"
      :visible.sync="dialogFormVisible"
      :append-to-body='true'
      top="10vh"
  >
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px">
      <el-form-item prop="type" label="类型">
        <el-select v-model="ruleForm.type" placeholder="请选择类型" :disabled="typeDisabled" @change="getUsedCount">
          <el-option
              v-for="item in TypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <span style="padding-left: 20px;">可使用数量: {{typeUsedCount}}</span>
      </el-form-item>
      <el-form-item prop="classId" label="产品">
        <el-select v-model="ruleForm.classId" placeholder="请选择产品" filterable>
          <el-option
              v-for="item in classOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="number" label="数量">
        <el-input v-model="ruleForm.number" :readonly="ruleForm.isAppoint" placeholder="请输入数量"></el-input>
        <span class="tsImg">单次生成数量不得大于50万</span>
      </el-form-item>
      <el-form-item prop="handleRule" label="编码规则" v-if="encodingType==0">
        <el-radio v-model="ruleForm.handleRule" :label="0">数字、字母组合</el-radio>
        <el-radio v-model="ruleForm.handleRule" :label="1">纯数字</el-radio>
      </el-form-item>
      <el-form-item prop="handleLength" label="编码长度" v-if="1==ruleForm.handleRule" >
        <el-input-number :min="12" v-model="ruleForm.handleLength"  placeholder="请输入编码长度"></el-input-number>
        <div class="input-tip"> 默认提供 10 亿不重复容量，点击「+」增加位数，每 + 1 位容量扩大 10 倍，按需扩容</div>
      </el-form-item>
      <el-form-item prop="scanNum" label="失效次数">
        <el-input v-model="ruleForm.scanNum" placeholder="请输入失效次数"></el-input>
        <span class="tsImg">用户扫码超过设定次数标识码将失效(-1表示不限次数)</span>
      </el-form-item>

      <el-form-item prop="outValue" label="扫码提醒阈值">
        <el-input v-model="ruleForm.outValue" placeholder="请输入数字"></el-input>
        <span class="tsImg">用户扫码超过设定次数系统将消息提醒企业管理员</span>
      </el-form-item>

      <el-form-item prop="verificationNum" label="验证次数">
        <el-input v-model="ruleForm.verificationNum" placeholder="请输入数字"></el-input>
        <span class="tsImg">用户验证超过设定次数后系统将提醒用户验证达上限</span>
      </el-form-item>
      <el-form-item prop="idenModelId" label="查询模板">
        <el-select v-model="ruleForm.idenModelId" placeholder="请选择类型">
          <el-option
              v-for="item in xiTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <span style="padding-left: 20px; color: #8A8A8A;">(顶级节点查询模版)</span>
      </el-form-item>
      <el-form-item prop="remark" label="备注">
        <el-input v-model="ruleForm.remark" type="textarea" rows="2" placeholder="请输入备注"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button class="btncss" @click="confirmCreateHandle()">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {fetchGetCustomCountByType,fetchCreateHandle,fetchIdenModelList}  from '@/api/customPage'
import {noPage} from '@/api/customPageClass.js'
	export default {
		data() {
			return {
        dialogFormVisible: false,
        ruleForm: {
          number: "",
          remark : "",
          scanNum: '', // -1为无限
          outValue: '',
          verificationNum: '',
          type: "", // 类型
          idenModelId: "", // 查询模板
          isRead: false,
          dealerId: null, // 经销商ID
          ratio: '',
          warnNum: 0, // 单箱窜货预警数
          isBind: false, // 是否关联产品/盒
          hasInCode: false, // 是否生成内码
          specCode: '',
          inCodeNumber: 15,
          isAppoint: false, // 是否制定文件
          handleCustomerId:null,
          multiCode:0,
          handleRule:1,
          handleLength:12,
          classId:''
        },
        rules: {
          scanNum: [{ required: true, message: "请输入失效次数", trigger: "blur" }],
          handleLength: [{ required: true, message: "请输入编码长度", trigger: "blur" }],
          number: [
            { required: true, message: "请输入数量", trigger: "blur" },
            { pattern: /^[1-9]\d*$/, message: '请输入正整数', trigger: 'blur'}
          ],
          ratio: [
            { required: true, message: "请输入比例", trigger: "blur" },
            { pattern: /^[1-9]\d*$/, message: '请输入正整数', trigger: 'blur'}
          ],
          warnNum: [
            { required: true, message: "请输入单箱窜货预警数", trigger: "blur" },
          ],
          hasInCode:[
            { required: true, message: "请选择是否生成内码", trigger: "change" },
          ],
          inCodeNumber:[
            { required: true, message: "请设置内码长度", trigger: "change" },
          ],
          outValue: [{ required: true, message: "请输入数字", trigger: "blur" }],
          verificationNum: [{ required: true, message: "请输入数字", trigger: "blur" }],
          type: [{ required: true, message: "请选择类型", trigger: "change" }],
          idenModelId:[{ required: true, message: "请选择模版类型", trigger: "change" }],
          classId:[{ required: true, message: "请选择产品", trigger: "change" }],
        },
        typeUsedCount: 0,
        TypeOptions:[
          {
            value: 1,
            label: '宣传物料（海报、彩页、手册、手提袋、纸巾包、钥匙扣等）'
          },
          {
            value: 2,
            label: '产品'
          },
          {
            value: 3,
            label: '箱标'
          },
          {
            value: 4,
            label: '证书'
          },
          {
            value: 5,
            label: '盒标'
          },
          {
            value: 6,
            label: '套标'
          },
        ],
        encodingType: 0,
        typeDisabled: false,
        xiTypeOptions:[],
        classOptions:[]
			}
		},
		components: {

		},
		watch: {

		},
		created() {

		},
    mounted() {
      this.getAllClass()
    },
		methods: {
      getAllClass(){
        noPage().then(res=>{
          this.classOptions = res.data
        })
      },
      async getIdenModelList(){
        let params = {
          companyId: JSON.parse(localStorage.getItem('info')).companyId,
          pageNum: 1,
          pageSize: 1000,
        }
        await fetchIdenModelList(params).then(res => {
          if(res.code === 200) {
            let arr = res.data.list.map(item => {
              return {
                label: item.idenModelNumber,
                value: item.id
              }
            })
            this.xiTypeOptions = [{ label: '默认', value: 0 },...arr]
          }
        })
      },
      async createHandle(){
        this.resetInner()
        await this.getIdenModelList()
        this.ruleForm.type = this.TypeOptions[1].value
        this.typeDisabled = false
        this.typeUsedCount= this.getUsedCount(this.ruleForm.type)
        if(this.typeUsedCount!== 0) {
          this.ruleForm.number = 1
        }else {
          this.ruleForm.number = 0
        }
        this.ruleForm.scanNum = -1
        this.ruleForm.outValue =  -1
        this.ruleForm.verificationNum = -1
        this.ruleForm.idenModelId = this.xiTypeOptions[0].value
        this.dialogFormVisible = true
      },
      getUsedCount(data) {
        this.resetInner()
        let params= {
          companyId: JSON.parse(localStorage.getItem('info')).companyId,
          type: data
        }
        fetchGetCustomCountByType(params).then(res => {
          this.typeUsedCount=res.data.count - res.data.usedCount
          this.ruleForm.handleLength = res.data.length
          if (res.data.rule){
            this.ruleForm.handleRule = res.data.rule
          }else {
            this.ruleForm.handleRule = 1
          }
          this.ruleForm.hasInCode = res.data.hasIncode
          this.ruleForm.inCodeNumber = res.data.inLength
        })
      },
      resetInner() {
        this.ruleForm.dealerId = null
        this.ruleForm.ratio = ''
        this.ruleForm.warnNum = 0
        this.ruleForm.hasInCode=false
        this.ruleForm.inCodeNumber= 15
        this.ruleForm.handleCustomerId = null
        this.ruleForm.isBind=false
        this.ruleForm.multiCode = 0
        this.ruleForm.handleLength = 12
        this.ruleForm.handleRule = 1
        this.ruleForm.remark = ''
        this.ruleForm.classId = null
      },
      closeDialog() {
        this.typeUsedCount = 0
        this.resetInner()
        this.dialogFormVisible = false
      },
      confirmCreateHandle() {
        let v= this
        this.$refs.ruleForm.validate(async (valid) => {
          if(Number(v.ruleForm.number) > this.typeUsedCount) {
            this.$message({
              message: '超出可使用数量',
              type: 'warning'
            });
            return
          }
          if(Number(v.ruleForm.number) > 500000) {
            this.$message({
              message: '单次生成数量不能大于50万',
              type: 'warning'
            });
            return
          }
          if (valid) {
            const loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            try {
              let params = {
                number: Number(v.ruleForm.number),
                remark: v.ruleForm.remark,
                type: v.ruleForm.type,
                scanNum: v.ruleForm.scanNum,
                idenModelId: v.ruleForm.idenModelId,
                isRead: v.ruleForm.isRead,
                outValue: v.ruleForm.outValue,
                verificationNum: v.ruleForm.verificationNum,
                dealerId: v.ruleForm.dealerId,
                isAppoint: v.ruleForm.isAppoint,
                handleCustomerId:v.ruleForm.handleCustomerId,
                multiCode:v.ruleForm.multiCode,
                handleLength:v.ruleForm.handleLength,
                specCode: v.ruleForm.specCode,
                handleRule:v.ruleForm.handleRule,
                classId: v.ruleForm.classId,
              }
              // 内码
              if(this.ruleForm.hasInCode) {
                params.hasInCode = this.ruleForm.hasInCode
                params.inCodeNumber = this.ruleForm.inCodeNumber
              }
              let res= await fetchCreateHandle(params);
              this.dialogFormVisible = false;
              if(res.code === 200) {
                this.$message({
                  type: "success" ,
                  message: "操作成功！",
                });
              }
              this.$emit('refreshList')
              loading.close()
            } catch (error) {
              loading.close()
            }
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
		},
	}
</script>
<style scoped>
.tsImg{
  color: #f77171;
  padding-top: 5px;
  font-size: 12px;
}
.input-tip {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
  line-height: 1.4;
}
</style>
